import React from 'react';
import VotingCard from './VotingCard';
import VotingCardMobile from './VotingCardMobile';

// 假數據用於演示
const mockArticles = [
  {
    id: '1',
    status: 'PUBLISHED',
    creator: { username: '約會專家' },
    voteCount: 156,
    commentCount: 23,
    viewCount: 342,
    favoriteCount: 12,
    question: {
      id: 'q1',
      title: '你更喜歡哪種約會方式？',
      description: '在現代社會中，約會方式越來越多元化。從傳統的餐廳約會到新興的戶外活動，每個人都有自己偏好的約會方式。',
      options: [
        { text: '餐廳約會', order: 0 },
        { text: '戶外活動', order: 1 },
        { text: '電影院', order: 2 },
        { text: '咖啡廳', order: 3 }
      ]
    },
    voteResults: [
      { optionIndex: 0, count: 45, percentage: 29 },
      { optionIndex: 1, count: 38, percentage: 24 },
      { optionIndex: 2, count: 32, percentage: 21 },
      { optionIndex: 3, count: 28, percentage: 18 },
      { optionIndex: 4, count: 13, percentage: 8 }
    ],
    createdAt: '2024-01-15T10:30:00Z',
    updatedAt: '2024-01-15T10:30:00Z'
  },
  {
    id: '2',
    status: 'PUBLISHED',
    creator: { username: '人生導師' },
    voteCount: 89,
    commentCount: 15,
    viewCount: 201,
    favoriteCount: 8,
    question: {
      id: 'q2',
      title: '你認為什麼是成功的關鍵？',
      description: '成功對每個人來說都有不同的定義。有人認為是事業成就，有人認為是家庭美滿，也有人認為是個人成長。',
      options: [
        { text: '努力工作', order: 0 },
        { text: '良好人際關係', order: 1 },
        { text: '持續學習', order: 2 },
        { text: '正確心態', order: 3 },
        { text: '運氣機會', order: 4 }
      ]
    },
    voteResults: [
      { optionIndex: 0, count: 25, percentage: 28 },
      { optionIndex: 1, count: 22, percentage: 25 },
      { optionIndex: 2, count: 20, percentage: 22 },
      { optionIndex: 3, count: 15, percentage: 17 },
      { optionIndex: 4, count: 7, percentage: 8 }
    ],
    createdAt: '2024-01-14T15:20:00Z',
    updatedAt: '2024-01-14T15:20:00Z'
  },
  {
    id: '3',
    status: 'PUBLISHED',
    creator: { username: '旅行達人' },
    voteCount: 203,
    commentCount: 31,
    viewCount: 456,
    favoriteCount: 25,
    question: {
      id: 'q3',
      title: '你更喜歡哪種旅行方式？',
      description: '旅行是放鬆心情、開闊視野的好方式。不同的旅行方式能帶來不同的體驗和感受。',
      options: [
        { text: '跟團旅遊', order: 0 },
        { text: '自由行', order: 1 },
        { text: '背包旅行', order: 2 },
        { text: '豪華度假', order: 3 },
        { text: '商務旅行', order: 4 }
      ]
    },
    voteResults: [
      { optionIndex: 0, count: 35, percentage: 17 },
      { optionIndex: 1, count: 58, percentage: 29 },
      { optionIndex: 2, count: 42, percentage: 21 },
      { optionIndex: 3, count: 38, percentage: 19 },
      { optionIndex: 4, count: 30, percentage: 14 }
    ],
    createdAt: '2024-01-13T09:15:00Z',
    updatedAt: '2024-01-13T09:15:00Z'
  }
];

const VotingDemo = () => {
  const handleVoteSuccess = (vote) => {
    console.log('投票成功:', vote);
    alert(`投票成功！你選擇了選項 ${vote.selectedOption + 1}`);
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      {/* 標題 */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">投票廣場 - 演示版</h1>
        <p className="text-gray-600">這是使用假數據的演示版本，展示投票功能</p>
      </div>

      {/* 統計資訊 */}
      <div className="mb-6">
        <div className="bg-white rounded-lg p-4 shadow-sm border">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 text-center">
            <div>
              <div className="text-2xl font-bold text-blue-600">3</div>
              <div className="text-sm text-gray-600">總投票數</div>
            </div>
            <div>
              <div className="text-2xl font-bold text-green-600">3</div>
              <div className="text-sm text-gray-600">進行中</div>
            </div>
            <div>
              <div className="text-2xl font-bold text-orange-600">448</div>
              <div className="text-sm text-gray-600">總參與人數</div>
            </div>
            <div>
              <div className="text-2xl font-bold text-purple-600">69</div>
              <div className="text-sm text-gray-600">總評論數</div>
            </div>
          </div>
        </div>
      </div>

      {/* 投票列表 */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {mockArticles.map((article) => (
          <React.Fragment key={article.id}>
            {/* 桌面端顯示 */}
            <div className="hidden md:block">
              <VotingCard
                article={article}
                onVoteSuccess={handleVoteSuccess}
              />
            </div>
            {/* 移動端顯示 */}
            <div className="md:hidden">
              <VotingCardMobile
                article={article}
                onVoteSuccess={handleVoteSuccess}
              />
            </div>
          </React.Fragment>
        ))}
      </div>

      {/* 說明 */}
      <div className="mt-8 text-center">
        <div className="bg-blue-50 rounded-lg p-4">
          <h3 className="text-lg font-semibold text-blue-900 mb-2">功能特色</h3>
          <ul className="text-blue-800 text-sm space-y-1">
            <li>• 直接在列表中查看題目前30字和完整選項</li>
            <li>• 一鍵投票，無需進入詳情頁</li>
            <li>• 即時顯示投票結果和百分比</li>
            <li>• 響應式設計，支援手機和桌面</li>
            <li>• 投票後立即更新統計數據</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default VotingDemo; 